import { EnvConfig } from '../../envConfig';

/**
 * Builds the public short URL a Gripp tag's QR code points to, e.g.
 * `https://www.gripp.it/<tagCode>` in production or
 * `https://nonprod.gripp.it/<tagCode>` in nonprod.
 *
 * Mirrors the environment-aware subdomain logic used by
 * `createInvitationUrl` so the generated link is correct per environment.
 */
export const createTagUrl = (tagCode: string): string => {
  const subDomain = EnvConfig.prefix === 'prod' ? 'www' : `${EnvConfig.prefix}`;

  return `https://${subDomain}.gripp.it/${tagCode}`;
};
